import { otto } from "../../exports/nexus.js";
import { defineEvent, defineNamespace, defineStore } from "../nexus/defines.js";
import { hashParams, paramsMap, searchParams } from "./params/params.js";
import { scope } from "./scope/scope.client.js";
import { getCurrentNavigation, initNavigationEvents } from "./lib/navigation.client.js";
import { initNativeHistory } from "./lib/history.client.js";
import { NAV_SCOPES, NAV_HISTORY } from "./lib/utils";
import type { NavigationCurrent } from "./lib/navigation.types";
import { navigate } from "./lib/navigate.client.js";
import { initScopes } from "./scope/init";

import { assignNamespace } from "../../common/assignNamespace";
import { o_util } from "../../common/namespaces";
import { stateMap } from "./state/state.js";

/*                                    */
assignNamespace(o_util, "navigation", { paramsMap, stateMap });

const [url, state, hash, search] = getCurrentNavigation();

otto.navigation.assignNamespace({
  current: defineStore<NavigationCurrent>({
    url,
    state,
    hash,
    search,
    type: "document",
  }),
  currentUrl: defineStore(url),
  currentState: defineStore(state),
  currentHash: defineStore(hash),
  currentSearch: defineStore(search),
  onNavigate: defineEvent(),

  hashParams,
  searchParams,

  navigate,
  scope,

  /*                                                                          */
  [NAV_SCOPES]: defineNamespace({}),

  /*                                         */
  [NAV_HISTORY]: initNativeHistory(),
});

if (!import.meta.env.SSR) {
  /*                                      */
  initNavigationEvents();

  /*                                                                    */
  /*                                                                             */
  initScopes();
}
